import React, { Component } from 'react';
import sparkles2 from '../asset/img/sparkles2.png';
import PropTypes from 'prop-types';

export default class AppChoice extends Component{
	constructor(props){
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick(e){ //method to pass up the app which has been chosen
		let identity = e.currentTarget.name;
		this.props.handleStateUpdate('app',identity);
	}
	render(){
		const buttonStyles={
			backgroundImage: 'url('+sparkles2+')',
			minHeight:'150px',
			maxWidth:'700px',
			margin:'auto',
			backgroundColor:'white'
		}
		return(
			<div style={{maxWidth:'700px',margin:'auto'}}>
				<div className="fl w-100 mv3 pa2">
					<button className="fl w-100 f2 b dark-blue shadow-3 br3" style={buttonStyles} name="lov" onClick={this.handleClick}>Living Our Values</button>
				</div>
				<div className="fl w-100 mv3 pa2">
					<button className="fl w-100 f2 b dark-blue shadow-3 br3" style={buttonStyles} name="asm" onClick={this.handleClick}>GF Promotional Orders</button>
				</div>
			</div>
		);
	}
}

AppChoice.propTypes = {
	handleStateUpdate: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/container/AppChoice.js